import React, { lazy, useEffect } from "react";

import Form from "../components/Form";

const Faq = lazy(() => import("../components/Faq"));

const FeaturesBenifits = lazy(() => import("../components/FeaturesBenifits"));
const AtmBranches = lazy(() => import("../components/AtmBranches"));
const FixDeposite = lazy(() => import("../components/FixDeposite"));
const DocumentRequired = lazy(() => import("../components/DocumentRequired"));
const Disclaimer = lazy(() => import("../components/disclaimer"));
const Footer = lazy(() => import("../components/Footer"));

function Home({ customADL, setCustomADL }) {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = window.gtag || gtag;
      window.gtag("js", new Date());
      window.gtag("config", "DC-8971752");
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/saving01+standard",
      });
    };
  }, []);


  return (
    <>
      <Form customADL={customADL} setCustomADL={setCustomADL} />
      <div style={{ marginTop: "210px" }}>
        <FeaturesBenifits />
      </div>
      <DocumentRequired />
      <AtmBranches />
      <FixDeposite />
      <Faq customADL={customADL} setCustomADL={setCustomADL} />
      <Disclaimer />
      <Footer customADL={customADL} setCustomADL={setCustomADL} />
    </>
  );
}

export default Home;
